module.exports = __webpack_public_path__ + "static/dashboard-mobile-f9bbe892e50bb679406dd300780cae5e.png";